var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime"; // @ts-nocheck

import React from 'react';
import { Box, Headline, Text, Line } from 'elemental-react';
;

var Section = function Section(_a) {
  var title = _a.title,
      titleColor = _a.titleColor,
      description = _a.description,
      children = _a.children;
  return _jsxs(Box, {
    children: [_jsxs(Box, __assign({
      px: 40,
      pt: 40
    }, {
      children: [_jsx(Headline.H2, __assign({
        bold: true,
        fontSize: 48,
        lineHeight: 64,
        color: titleColor
      }, {
        children: title
      }), void 0), Boolean(description) && _jsx(Text, __assign({
        fontSize: 20,
        lineHeight: 24,
        color: "#6E7379",
        mt: 12
      }, {
        children: description
      }), void 0), _jsx(Line, {
        mt: 16,
        bg: "#D8D8D8",
        width: "100%"
      }, void 0)]
    }), void 0), children]
  }, void 0);
};

export default Section;